import { __spread, __values, __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

var DatatableComponent = /** @class */ (function () {
    function DatatableComponent( // private ref
    ) {
        var _this = this;
        this.feedback = new EventEmitter(null);
        this.noOfRows = [10];
        this.refreshing = false;
        this.cache = {
            checkBoxHeadId: ''
        };
        this.headHash = {};
        this.tableId = 'a' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        this.noOfRowsInterval = 10;
        this.paginate = 10;
        this.paginateIndex = 1;
        this.paginateArrayIndex = 1;
        this.totalAvailablePagination = 1;
        this.staticBodyrows = [];
        this.subs = [];
        this.paginatedBodyrows = [];
        this.logger = function (text, color) {
            if (_this.options && _this.options.debug) {
                console.log("%c " + text, 'color:' + (color || 'blue'));
            }
        };
        this.headClicked = function (headData, refElement) {
            switch (headData.key) {
                case 'checkbox':
                    _this.cache.checkBoxHeadId = refElement;
                    var previouslyChecked_1 = _this.allPaginatedRowsChecked;
                    console.log({ previouslyChecked: previouslyChecked_1 });
                    _this.paginatedBodyrows.forEach(function (row) {
                        if (previouslyChecked_1) {
                            row.checkbox = false;
                        }
                        else {
                            row.checkbox = true;
                        }
                    });
                    setTimeout(function () {
                        _this.allPaginatedRowsChecked = !previouslyChecked_1;
                    }, 100);
                    _this.emitSelectedRows();
                    break;
                default:
                    var sorted_1 = _this.headHash[headData.key].sorted;
                    _this.bodyrows.sort(function (a, b) {
                        if (sorted_1) {
                            _this.headHash[headData.key] = { sorted: false };
                            var temp = a;
                            a = b;
                            b = temp;
                        }
                        else {
                            _this.headHash[headData.key] = { sorted: true };
                        }
                        var type = headData.type;
                        if (!headData.type) {
                            // possibly a number
                            if (parseInt(_this.getData(headData.key, a)) && parseInt(_this.getData(headData.key, b))) {
                                type = 'number';
                            }
                            else {
                                type = 'string';
                            }
                        }
                        switch (type) {
                            case 'number':
                                return a[headData.key] - b[headData.key];
                            case 'date':
                                return (Number(new Date(a[headData.key])) || 0) - (Number(new Date(b[headData.key])) || 0);
                            case 'string':
                                var nameA = _this.getData(headData.key, a) ? (_this.getData(headData.key, a) + '').toUpperCase() : ''; // ignore upper and lowercase
                                var nameB = _this.getData(headData.key, b) ? (_this.getData(headData.key, b) + '').toUpperCase() : ''; // ignore upper and lowercase
                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                // names must be equal
                                return 0;
                            default:
                                break;
                        }
                    });
                    _this.startPaginate();
                    break;
            }
            var el = document
                .querySelector('#' + _this.tableId)
                .querySelector('#' + headData.key + '-icon');
            if (!el) {
                return;
            }
            if (_this.headHash[headData.key].sorted) {
                el.innerHTML = "  <i class='fa  fa-angle-up'></i>";
            }
            else {
                el.innerHTML = "  <i class='fa  fa-angle-down'></i>";
            }
        };
        this.initializeTable = function () {
            if ((_this.bodyrows || []).length > _this.paginate) {
                _this.noOfRows = [];
                var displayCountSeen = false;
                for (var i = 1; i <= Math.ceil(_this.bodyrows.length / _this.noOfRowsInterval); i++) {
                    if ((_this.noOfRowsInterval * i) == _this.paginate) {
                        displayCountSeen = true;
                    }
                    _this.noOfRows.push(_this.noOfRowsInterval * i);
                }
                if (!displayCountSeen) {
                    _this.noOfRows.push(_this.paginate);
                    _this.noOfRows.sort();
                }
            }
            _this.heads.forEach(function (head) {
                _this.headHash[head.key] = { sorted: false };
            });
            _this.startPaginate(true);
        };
        this.startPaginate = function (init) {
            if (!_this.bodyrows) {
                return;
            }
            if (init) {
                _this.totalAvailablePagination = Math.ceil(_this.bodyrows.length / _this.paginate) || 1;
            }
            _this.paginatedBodyrows = _this.bodyrows.slice(_this.paginateArrayIndex - 1, _this.paginate + (_this.paginateArrayIndex - 1));
            _this.emitSelectedRows();
            _this.resetCheckBox();
        };
        this.allPaginatedRowsChecked = false;
    }
    DatatableComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.options) {
            if (this.options.noOfRowsToDisplay) {
                this.paginate = this.options.noOfRowsToDisplay;
            }
            if (this.options.noOfRowsInterval) {
                this.noOfRowsInterval = this.options.noOfRowsInterval;
            }
            else {
                // this.noOfRowsInterval = this.paginate;
            }
            if (this.options.debug) {
                this.logger('Debug mode is on. do not forget to turn it off when you are done', 'red');
            }
        }
        if (this.dataChanged) {
            this.subs.push(this.dataChanged.subscribe(function (changed) {
                if (changed) {
                    _this.refreshing = true;
                    _this.logger('detected data change');
                    setTimeout(function () {
                        _this.refreshing = false;
                        _this.staticBodyrows = _this.bodyrows ? __spread(_this.bodyrows) : [];
                        _this.paginateIndex = 1;
                        _this.paginateArrayIndex = 1;
                        _this.initializeTable();
                        //    this.ref.detectChanges()
                    }, 1000);
                }
            }));
        }
        ;
        this.staticBodyrows = this.bodyrows ? __spread(this.bodyrows) : [];
        this.initializeTable();
        //    this.ref.detectChanges()
    };
    DatatableComponent.prototype.nextPaginate = function (n, forced) {
        if (forced && typeof forced !== 'number') {
            return;
        }
        if (forced) {
            this.paginateIndex = forced;
            this.paginateArrayIndex = (forced * this.paginate);
        }
        else {
            this.paginateIndex += (n);
            this.paginateArrayIndex += (n * this.paginate);
        }
        this.startPaginate();
        this.resetCheckBox();
    };
    DatatableComponent.prototype.changePagination = function (n) {
        this.paginate = parseInt(n);
        this.paginateIndex = 1;
        this.paginateArrayIndex = 1;
        this.initializeTable();
    };
    DatatableComponent.prototype.search = function (searchInput) {
        this.bodyrows = this.staticBodyrows.filter(function (obj) {
            var e_1, _a;
            var match = false;
            try {
                for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    if ((obj[key] + '').toLowerCase().match(searchInput.trim().toLowerCase())) {
                        match = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return match;
        });
        this.startPaginate(true);
    };
    DatatableComponent.prototype.resetCheckBox = function () {
        this.logger('validating checkbox');
        for (var i = 0; i < this.paginatedBodyrows.length; i++) {
            var row = this.paginatedBodyrows[i];
            if (row.checkbox) {
                this.allPaginatedRowsChecked = true;
            }
            else {
                this.allPaginatedRowsChecked = false;
                return;
            }
        }
        this.paginatedBodyrows.forEach(function (_) { return _; });
    };
    DatatableComponent.prototype.itemChecked = function (data, checked, bodyIndex) {
        data.checkbox = checked;
        this.emitSelectedRows();
        this.resetCheckBox();
    };
    DatatableComponent.prototype.emitSelectedRows = function (plain) {
        var selectedrows = this.bodyrows.filter(function (rdata) { return rdata.checkbox; });
        if (plain) {
            return selectedrows;
        }
        this.feedback.emit({ type: 'selectedrows', data: selectedrows });
    };
    DatatableComponent.prototype.emitSingleAction = function (action, data) {
        this.feedback.emit({ type: 'singleaction', action: action, data: data });
    };
    DatatableComponent.prototype.emitBulkAction = function (action) {
        this.feedback.emit({ type: 'bulkactions', action: action, data: this.emitSelectedRows(true) });
    };
    DatatableComponent.prototype.min = function (a, b) {
        return Math.min(a, b);
    };
    DatatableComponent.prototype.emitViewActions = function (data, key) {
        var _this = this;
        if (key === 'checkbox' || key === 'action') {
            return;
        }
        if (this.options.emitClickActions) {
            this.options.emitClickActions.forEach(function (action) { return _this.feedback.emit({ type: 'singleaction', action: action, data: data }); });
            return;
        }
        ['View/Edit', 'View / Edit', 'View', 'Edit'].forEach(function (action) { return _this.feedback.emit({ type: 'singleaction', action: action, data: data }); });
    };
    DatatableComponent.prototype.getData = function (key, rowData) {
        var periodArr = key.split('.');
        if (periodArr) {
            var stageData_1 = rowData;
            periodArr.forEach(function (eachPeriod) {
                if (stageData_1) {
                    stageData_1 = stageData_1[eachPeriod];
                }
            });
            return stageData_1;
        }
        return rowData[key];
    };
    DatatableComponent.prototype.populateShortcutPagnation = function (start, end) {
        var a = 5;
        // this.paginateIndex
        var arr = [];
        for (var i = start; i <= end; i++) {
            arr.push(i);
        }
        return arr;
    };
    DatatableComponent.prototype.mouseOverPagnation = function ($event) {
        var el = $event.target
            .querySelector('.pagnate-display');
        if (!el || !$event) {
            return;
        }
        el.style.top = "-" + el.clientHeight + "px";
        el.style.left = "-" + ((el.clientWidth / 2) - ($event.target.clientWidth / 2)) + "px";
    };
    DatatableComponent.prototype.processFieldWithPipe = function (pipe, field) {
        var _a;
        if (!pipe.pipe) {
            this.logger('Cannot find pipe function');
            return '';
        }
        return (_a = pipe.pipe).transform.apply(_a, __spread([field], pipe.args));
    };
    DatatableComponent.prototype.OnDestroy = function () {
        this.subs.forEach(function (sub) { return sub.unsubscribe(); });
    };
    __decorate([
        Input()
    ], DatatableComponent.prototype, "tableContainerClass", void 0);
    __decorate([
        Input()
    ], DatatableComponent.prototype, "tableClass", void 0);
    __decorate([
        Input()
    ], DatatableComponent.prototype, "options", void 0);
    __decorate([
        Input()
    ], DatatableComponent.prototype, "heads", void 0);
    __decorate([
        Input()
    ], DatatableComponent.prototype, "bodyrows", void 0);
    __decorate([
        Input()
    ], DatatableComponent.prototype, "dataChanged", void 0);
    __decorate([
        Output()
    ], DatatableComponent.prototype, "feedback", void 0);
    DatatableComponent = __decorate([
        Component({
            selector: 'inn-datatable',
            template: "<div *ngIf=\"bodyrows\" [id]='tableId' class=\"t {{tableContainerClass}}\">\r\n  <div class=\"text-muted row mb-1 top-options\">\r\n    <div class=\"col-12 mt-2 col-lg-9 text-left\">\r\n   <ayo-dropdown [togglePosition]=\"{top: 30}\">\r\n        <div class=\"d-inline-block text-left mr-2\">\r\n          <button toggle-parent *ngIf=\"\r\n                    options && options.bulkActions && options.bulkActions.length > 0\r\n                  \" class=\"btn btn-outline-primary btn-sm\">\r\n            ACTIONS\r\n            <span><img src=\"img/caret_down_blue.svg\" width=\"13\" alt=\"\" /></span>\r\n          </button>\r\n          <div toggle class='border rounded bg-white' style='width: 200px'>\r\n            <a (click)=\"emitBulkAction(action)\" *ngFor=\"let action of options.bulkActions\" class='p-2 list-group-item-action dropdown-item'>\r\n              {{ action }}</a>\r\n          </div>\r\n        </div>\r\n   </ayo-dropdown>\r\n      <div class=\"d-inline-block text-left mr-2\">\r\n      \r\n        <select\r\n        \r\n          style=\"height: 30px; position: relative; top: 2px;\"\r\n          class=\"search border rounded paginate-select\"\r\n          #paginateSelect\r\n          (change)=\"changePagination(paginateSelect.value)\"\r\n        >\r\n          <option [value]='no' [selected]='paginate == no' *ngFor='let no of  noOfRows' >{{no}}</option>\r\n     \r\n        </select>\r\n      </div>\r\n      <div *ngIf=\"refreshing\" class=\"d-inline-block text-left mr-2\">\r\n        <i><small>Refreshing... </small></i>\r\n        <i class=\"fa fa-spinner\"></i>\r\n      </div>\r\n      <div\r\n        *ngIf=\"bodyrows && bodyrows.length === 0\"\r\n        class=\"d-inline-block text-left mr-2 text-muted\"\r\n      >\r\n        <i class=\"fa fa-info-circle\"></i> No data to show\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 mt-2 col-md-6 col-lg-3 text-right\">\r\n      <input\r\n        #searchInput\r\n        class=\"pl-2 border rounded search\"\r\n        placeholder=\"Search\"\r\n        (input)=\"search(searchInput.value)\"\r\n      />\r\n    </div>\r\n\r\n    <!--sdsdsds dsdsds-->\r\n  </div>\r\n  <div class=\"data-table-container\">\r\n    <table cellspacing=\"0\" width=\"100% \" [class]=\"tableClass\">\r\n      <thead>\r\n        <tr>\r\n          <th\r\n            style=\"position: relative;\"\r\n            *ngFor=\"let head of heads; index as headIndex\"\r\n            class=\"th-sm\"\r\n          >\r\n            <div\r\n              *ngIf=\"head.key === 'checkbox'\"\r\n              class=\"custom-control custom-checkbox d-block text-center other-body\"\r\n            >\r\n              <input\r\n                id=\"{{ 'checkbox-head' + headIndex }}\"\r\n                [checked]='allPaginatedRowsChecked'\r\n                type=\"checkbox\"\r\n                class=\"custom-control-input text-center\"\r\n              />\r\n\r\n              <label\r\n                (click)=\"\r\n                  headClicked(head, 'checkbox-head' + headIndex)\r\n                \"\r\n                class=\"custom-control-label\"\r\n                for=\"{{ 'checkbox-head' + headIndex }}\"\r\n              ></label>\r\n            </div>\r\n            <div *ngIf=\"head.key === 'action'\" class='other-body'>\r\n              {{ head.title }}\r\n            </div>\r\n            <span\r\n              class=\"cursor each-useful-body \"\r\n              (click)=\"headClicked(head)\"\r\n              *ngIf=\"head.key !== 'action' && head.key !== 'checkbox'\"\r\n            >\r\n              {{ head.title }}\r\n\r\n              <span style=\"width: 20px;\"></span>\r\n            </span>\r\n\r\n            <button\r\n            title='sort list'\r\n              class=\"sort-button ml-2\"\r\n              (click)=\"headClicked(head)\"\r\n              *ngIf=\"head.key !== 'action' && head.key !== 'checkbox'\"\r\n              id=\"{{ head.key }}-icon\"\r\n            >\r\n              <i class=\"fa fa-angle-down\"></i>\r\n            </button>\r\n          </th>\r\n        </tr>\r\n      </thead>\r\n      <tbody class=\"border box-shadow-deep\">\r\n        <tr *ngFor=\"let row of paginatedBodyrows; let bodyIndex = index\">\r\n          <td\r\n            *ngFor=\"let head of heads\"\r\n            (click)=\"emitViewActions(row, head.key)\"\r\n          >\r\n            <div\r\n              *ngIf=\"head.key === 'checkbox'\"\r\n           \r\n              class=\"custom-control custom-checkbox d-block text-center other-body\"\r\n            >\r\n              <input\r\n                (change)=\"itemChecked(row, $event.target.checked,bodyIndex)\"\r\n                [checked]=\"getData(head.key, row) ? true : false\"\r\n\r\n                id=\"{{ 'checkbox' + bodyIndex }}\"\r\n                type=\"checkbox\"\r\n                class=\"custom-control-input text-center checkbox\"\r\n              />\r\n              <label\r\n                class=\"custom-control-label\"\r\n                for=\"{{ 'checkbox' + bodyIndex }}\"\r\n              ></label>\r\n            </div>\r\n            <span class='other-body' *ngIf=\"head.key === 'action'\">\r\n   \r\n              <ayo-dropdown [togglePosition]=\"{left: -200}\" >\r\n              <span toggle-parent class=\"p-2\">\r\n                <i class='fa fa-ellipsis-h'></i>\r\n              </span>\r\n\r\n                  <div toggle class='border rounded bg-white' style='width: 200px'>\r\n                  <div *ngFor=\"let action of options.singleActions\" >\r\n                      <a class='p-2 list-group-item-action dropdown-item' (click)=\"\r\n                                            emitSingleAction(\r\n                                              action.title ? action.title : action,\r\n                                              row\r\n                                            )\r\n                                          \" *ngIf=\"\r\n                                            !action.showIf ||\r\n                                            (action.showIf && action.showIf(getData(head.key, row), row))\r\n                                          \">\r\n                        {{ action.title ? action.title : action }}\r\n                    \r\n                      </a>\r\n                    </div>\r\n                   \r\n                  </div>\r\n               \r\n              </ayo-dropdown>\r\n               \r\n               \r\n              \r\n            </span>\r\n            <span class=\"each-useful-body\" *ngIf=\"head.key !== 'action' && head.key !== 'checkbox'\">\r\n             \r\n              <span *ngIf='!head.html'>{{\r\n                head.transform\r\n                  ?  head.transform(getData(head.key, row), row)\r\n                  : getData(head.key, row)\r\n              }}</span>\r\n\r\n              <span *ngIf='head.html' [innerHTML]=\" head.transform ? head.html(head.transform(getData(head.key, row), row)) : head.html(getData(head.key, row))\"></span>\r\n            </span>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n  <div class='row'>\r\n\r\n \r\n  <div class=\"col-md-6 text-muted mt-2\">\r\n    Showing {{ min(paginate * paginateIndex, bodyrows.length) }} of\r\n    {{ bodyrows.length }} results\r\n  </div>\r\n  <div class=\"col-md-6 text-right text-muted mt-2\">\r\n    <button\r\n      (click)=\"nextPaginate(-1)\"\r\n      *ngIf=\"paginateIndex !== 1\"\r\n      class=\"mr-1 cursor btn btn-small-l btn-primary\"\r\n    >\r\n      previous\r\n    </button>\r\n    <div class='d-inline-block pagnate-display-short'  (mouseover)=\"mouseOverPagnation($event)\">\r\n    <b>{{ paginateIndex }} </b> / {{ totalAvailablePagination }}\r\n   \r\n   \r\n    <div class=' pl-2 pt-2 pr-2 pagnate-display bg-white rounded text-left border rounded box-shadow'>\r\n      <span class='cursor' [ngClass]=\"{'text-primary font-weight-bold': number === paginateIndex}\"\r\n        (click)=\"nextPaginate(null, number)\"\r\n        *ngFor=\"let number of populateShortcutPagnation(1, totalAvailablePagination); index as i\">\r\n        {{i !== 1 ? '' : ','}}\r\n        {{number}}\r\n      </span>\r\n    </div>\r\n    </div>\r\n\r\n    \r\n\r\n    <button\r\n      (click)=\"nextPaginate(1)\"\r\n      *ngIf=\"paginateIndex < totalAvailablePagination\"\r\n      class=\"ml-1 cursor btn btn-small-l btn-primary\"\r\n    >\r\n      Next\r\n    </button>\r\n  </div>\r\n</div>\r\n</div>\r\n\r\n<div class=\"text-center p-2 text-muted\" *ngIf=\"!bodyrows\">\r\n  <i class=\"fa fa-spinner\"></i> Loading data\r\n</div>\r\n\r\n<br />\r\n<br />\r\n",
            styles: [".cursor{cursor:pointer}.t{margin-top:30px}.data-table-container{width:100%;height:auto!important;overflow-x:auto}.each-useful-body{display:inline;min-width:100px;overflow:hidden}.other-body{min-width:50px}thead th{white-space:nowrap}.data-table-container:hover .top-options{visibility:visible}.btn-small-l{height:30px!important;width:auto!important;padding:5px 10px!important;font-size:12px}.sort-button{cursor:pointer;border:none}.custom-control-label{position:relative;top:-13px}table{border-spacing:1;border-collapse:collapse;border-radius:9px;width:100%;margin:0 auto}table body{background:#fff}td a{cursor:pointer}td,th{padding-left:8px}thead tr{height:60px;border-bottom:1px solid #dee2ed;font-style:normal;font-weight:600;font-size:13px;color:#19233c}tbody tr{height:75px;border-bottom:1px solid #dee2ed;border-radius:20px;font-style:normal;font-weight:300;font-size:14px;color:#455a64}.search{height:30px}.fa-spinner{-webkit-animation-name:spin;animation-name:spin;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.box-shadow{box-shadow:0 .25rem .75rem rgba(0,0,0,.05)}.box-shadow-deep{box-shadow:0 5px 23px rgba(0,0,0,.05)!important}.pagnate-display-short{position:relative;z-index:2}.pagnate-display-short .pagnate-display{display:none;width:200px;vertical-align:top;position:absolute;top:-10px;left:0}.pagnate-display-short:hover .pagnate-display{display:block}@-webkit-keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}"]
        })
    ], DatatableComponent);
    return DatatableComponent;
}());

var DropdownComponent = /** @class */ (function () {
    function DropdownComponent() {
        var _this = this;
        this.clicked = false;
        this.canClickOutside = false;
        this.clickedFunRef = function (e) {
            if (!_this.isDescendant(_this.toggleEl, e.target) && _this.canClickOutside) {
                _this.toggleClicked();
            }
        };
        this.scrollFunRef = function (e) {
            _this.toggleClicked();
        };
    }
    DropdownComponent.prototype.ngOnInit = function () {
    };
    DropdownComponent.prototype.getPos = function () {
        this.pos = this.myDivElementRef.nativeElement.getBoundingClientRect();
    };
    DropdownComponent.prototype.isDescendant = function (parent, child) {
        var node = child.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };
    DropdownComponent.prototype.toggleClicked = function () {
        var _this = this;
        this.clicked = !this.clicked;
        if (this.clicked) {
            this.getPos();
            this.toggleEl.style.display = 'block';
            this.toggleEl.style.position = 'fixed';
            this.toggleEl.style.top = (this.pos.top + ((this.togglePosition || {})['top'] || 0)) + 'px';
            this.toggleEl.style.left = (this.pos.left + ((this.togglePosition || {})['left'] || 0)) + 'px';
            this.myDivElementRef.nativeElement.style.zIndex = '6';
            if (this.canClickOutsideSetTimeoutRef) {
                clearTimeout(this.canClickOutsideSetTimeoutRef);
            }
            this.canClickOutsideSetTimeoutRef = setTimeout(function () {
                _this.canClickOutside = true;
            }, 100);
            window.addEventListener('click', this.clickedFunRef);
            window.addEventListener('scroll', this.scrollFunRef);
        }
        else {
            this.canClickOutside = false;
            this.toggleEl.style.display = 'none';
            this.myDivElementRef.nativeElement.style.zIndex = '2';
            this.ngOnDestroy();
        }
    };
    DropdownComponent.prototype.ngAfterViewInit = function () {
        this.toggleEl = this.myDivElementRef.nativeElement.querySelector('[toggle]');
        this.toggleEl.style.display = 'none';
        this.toggleEl.style.position = 'absolute';
    };
    DropdownComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('click', this.clickedFunRef);
        window.removeEventListener('scroll', this.scrollFunRef);
    };
    __decorate([
        ViewChild('Dropdown')
    ], DropdownComponent.prototype, "myDivElementRef", void 0);
    __decorate([
        Input()
    ], DropdownComponent.prototype, "togglePosition", void 0);
    DropdownComponent = __decorate([
        Component({
            selector: 'ayo-dropdown',
            template: "<div (click)='toggleClicked()' #Dropdown class=\"d-inline-block dropdown\">\n\n    <ng-content></ng-content>\n\n\n</div>",
            styles: [".dropdown{position:relative;z-index:2}"]
        })
    ], DropdownComponent);
    return DropdownComponent;
}());

var DatatableModule = /** @class */ (function () {
    function DatatableModule() {
    }
    DatatableModule = __decorate([
        NgModule({
            declarations: [DatatableComponent, DropdownComponent],
            imports: [
                CommonModule
            ],
            exports: [DatatableComponent, DropdownComponent]
        })
    ], DatatableModule);
    return DatatableModule;
}());

;
[];

var types = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
 * Generated bundle index. Do not edit.
 */

export { types as DataTableTypes, DatatableModule, DatatableComponent as ɵa, DropdownComponent as ɵb };
//# sourceMappingURL=inn-datatable.js.map
